import React from 'react';

const ArcTwo = ({
  fill = 'white',
  stroke = 'rgba(240, 0, 55, 0.06)',
  strokeWidth = 1,
  className = '',
}) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="211"
        height="137"
        viewBox="0 0 211 137"
        fill="none"
        className={className}

      >
        <path
          d="M1.7448 13.9485C-0.38502 11.204 0.990219 7.18325 4.37998 6.42332C32.6825 0.0783606 63.6998 -1.21597 93.3885 2.76658C125.595 7.08679 154.465 17.379 175.588 32.0699C196.71 46.7609 208.922 65.0424 210.357 84.1201C211.659 101.43 204.024 118.531 188.527 133.275C185.545 136.112 181.153 136.762 177.331 135.232C173.392 133.655 172.551 128.408 175.497 125.354C187.454 112.96 193.285 98.8482 192.212 84.5754C190.949 67.7871 180.202 51.6993 161.615 38.7713C143.027 25.8432 117.621 16.7861 89.2795 12.9843C62.5758 9.40219 34.6506 10.6713 9.30348 16.5791C6.48328 17.2364 3.52018 16.2362 1.7448 13.9485Z"
          fill={fill}
          stroke={stroke}
          style={{
            mixBlendMode: 'multiply',
            filter: 'blur(1px)',
          }}

        />
        <path
          d="M4.48889 6.91113C32.2909 0.678376 62.7237 -0.670764 91.9323 3.08008L93.3219 3.26172C124.967 7.50672 153.359 17.5258 174.31 31.7978L175.302 32.4805C196.018 46.8884 208.058 64.7112 209.784 83.2734L209.859 84.1572C211.127 101.015 203.833 117.715 188.9 132.224L188.183 132.912C185.444 135.518 181.435 136.192 177.861 134.899L177.516 134.768C174.058 133.383 173.182 128.829 175.612 125.973L175.857 125.701C187.702 113.423 193.611 99.4276 192.756 85.2148L192.711 84.5381C191.453 67.8174 180.903 51.8499 162.769 38.9717L161.9 38.3603C143.524 25.5796 118.541 16.5828 90.6754 12.6709L89.3463 12.4883C63.4209 9.01055 36.3461 10.0957 11.5797 15.5508L9.19006 16.0918C6.63567 16.6872 3.96342 15.8271 2.29749 13.8379L2.14026 13.6416C0.286612 11.253 1.39565 7.8116 4.21155 6.9834L4.48889 6.91113Z"
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeOpacity="0.06"
        />
      </svg>
    </>
  );
};

export default ArcTwo;
